import { Facebook } from "lucide-react";
const Footer = () => {
  return <footer className="bg-foreground text-background py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-center md:text-left">
            <p className="text-sm">© 2026 Referral Connection Network. All rights reserved.</p>
            <p className="text-sm text-background/70 mt-1">
              Web Design by{" "}
              <a href="http://ewm.tech" target="_blank" rel="noopener noreferrer" className="hover:text-background transition-colors underline">
                EWM Solutions
              </a>{" "}
              – Washington Missouri
            </p>
          </div>

          <a href="https://www.facebook.com/profile.php?id=61566386020729&sk=about" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity" aria-label="Visit our Facebook page">
            <Facebook className="h-6 w-6" />
          </a>
        </div>
      </div>
    </footer>;
};
export default Footer;